import { ResourceOptions } from 'react-admin';
import { MdWallet } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayHotWallets;
export {
  XBIT_RELAY_HOT_WALLETS_PERMISSION_RESOURCE,
  XBIT_RELAY_PROVIDERS_PERMISSION_RESOURCE,
} from './constants';
export const icon = MdWallet;
export const options: ResourceOptions = {
  label: 'module.xbitRelayHotWallets.title',
};
